import { memo, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { activeReportAlarmState, reportAlarmLngLatsState, reportAlarmsState } from '../../../storage/reports';
import ReportAlarmMarker from './ReportAlarmMarker';

function ReportAlarmsMarkers() {
  const assetId = useRecoilValue(activeReportAlarmState);
  const states = useRecoilValue(reportAlarmsState(assetId || ''));
  const lngLats = useRecoilValue(reportAlarmLngLatsState(assetId || ''));
  const { fitToLngLats } = useCamera();

  useEffect(() => {
    if (!lngLats.length) return;

    fitToLngLats(lngLats);
  }, [lngLats, assetId, fitToLngLats]);

  if (!states?.length || !assetId) return null;

  return (
    <>
      {states.map((state, index) => {
        return (
          <ReportAlarmMarker
            key={index}
            alarm={state}
          />
        );
      })}
    </>
  );
}

export default memo(ReportAlarmsMarkers);
